import { render, staticRenderFns } from "./newBusiness.vue?vue&type=template&id=f053fd46&"
import script from "./newBusiness.vue?vue&type=script&lang=js&"
export * from "./newBusiness.vue?vue&type=script&lang=js&"
import style0 from "./newBusiness.vue?vue&type=style&index=0&id=f053fd46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports